export default "__VITE_ASSET__CXkbwzfT__"